import { cn } from "@/lib/utils";
import { Button } from "@/components/shadcn/button";
import {
  Braces,
  CodeXml,
  List,
  Maximize2,
  Bold,
  Italic,
  Underline,
  Copy,
} from "lucide-react";
import { useCallback } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/shadcn/tooltip";

interface IToolbarButtons {
  label: string;
  type:
    | "code"
    | "list"
    | "expand"
    | "raw"
    | "bold"
    | "italic"
    | "underline"
    | "copy";
  onClick: () => any;
  isDisabled?: boolean;
  isActive?: boolean;
}

const ToolbarButton = ({
  label,
  type,
  onClick,
  isDisabled,
  isActive,
}: IToolbarButtons) => {
  const Icon = useCallback(() => {
    switch (type) {
      case "bold":
        return Bold;
      case "italic":
        return Italic;
      case "underline":
        return Underline;
      case "code":
        return CodeXml;
      case "expand":
        return Maximize2;
      case "list":
        return List;
      case "raw":
        return Braces;
      case "copy":
        return Copy;
      default:
        return List;
    }
  }, [type]);

  const ToolbarIcon = Icon();
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="iconsm"
          onClick={onClick}
          isDisabled={isDisabled}
          tabIndex={-1}
          className={cn(isActive && "bg-accent text-accent-foreground")}
        >
          <ToolbarIcon className="size-4" strokeWidth={1.25} />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{label}</TooltipContent>
    </Tooltip>
  );
};

export default ToolbarButton;
